export const CANDIDATES_RESET_STATE = 'CANDIDATES_RESET_STATE';
export const CANDIDATES_CURRENT_ITEM = 'CANDIDATES_CURRENT_ITEM';

export const CANDIDATES_REQUEST_LOADING = 'CANDIDATES_REQUEST_LOADING';
export const CANDIDATES_REQUEST_SUCCESS = 'CANDIDATES_REQUEST_SUCCESS';
export const CANDIDATES_REQUEST_FAILED = 'CANDIDATES_REQUEST_FAILED';

export const CANDIDATES_CURRENT_ACTION = 'CANDIDATES_CURRENT_ACTION';
export const CANDIDATES_RESET_ACTION = 'CANDIDATES_RESET_ACTION';
